import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Button, Col, Divider, Form, Input, Row, Select, Switch, TreeSelect, Typography, Modal as modalant } from "antd";
import { MaskedInput } from 'antd-mask-input';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { success_message } from "../../components/Toastr";
import { TreeSelectLocationBase } from "../../components/TreeSelectLocation";
import { TreeSelectTopic } from "../../components/TreeSelectTopic";
import { UserPicker } from "../../components/UserPicker";
import { useAuth } from "../../hooks/auth";
import Api, { exceptionNotificationAPI } from "../../services/api";
import { ContentModal } from "./styles";

const { Option } = Select;
const { confirm } = modalant;

const FormUser = ({ getUserListData, closeModal, rolesList, usersList, languagesList, tenantIsSSOEnabled, userFormSelected = null, readOnly }) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    let navigate = useNavigate();
    const [baseUserLocation, setBaseUserLocation] = useState();
    const { can, user } = useAuth();
    const [parentId, setParentId] = useState();
    const [isSSOUser, setIsSSOUser] = useState(false);
    const [showOnlyMyTasks, setShowOnlyMyTasks] = useState(false);

    useEffect(() => {
        form.resetFields();

        setBaseUserLocation(user.companyLocationId);
        if (userFormSelected.id) {
            let roles = [];
            let topics = [];

            if (userFormSelected.profiles.length > 0) {
                roles = userFormSelected.profiles.map((profile) => {
                    if (profile.topics.length > 0) {
                        const topics1 = profile.topics.map((topic) => {
                            return topic.topicId;
                        });

                        topics = topics.concat(topics1);
                    }

                    return profile.roleId;
                });
            }

            topics = topics.filter((v, i, a) => a.indexOf(v) === i);
            const parentLocationName = getParentLocationName(usersList, userFormSelected.parentId);
            form.setFieldsValue({
                name: userFormSelected.name,
                userName: userFormSelected.userName,
                email: userFormSelected.email,
                phoneNumber: userFormSelected.phoneNumber,
                locationId: userFormSelected.locationId,
                companyLocationId: userFormSelected.companyLocationId,
                builderLocationId: userFormSelected.builderLocations,
                roleId: roles,
                topicId: topics,
                isActive: userFormSelected.isActive,
                languageId: userFormSelected.languageId,
                parentId: userFormSelected.parentId,
                parentLocationName: parentLocationName,
                isSSOUser: userFormSelected.isSSOUser,
                ssoSignInInformation: userFormSelected.ssoSignInInformation,
                readOnly: readOnly,
                showOnlyMyTasks: userFormSelected.showOnlyMyTasks,
            });
            setShowOnlyMyTasks(userFormSelected.showOnlyMyTasks || false);
            setIsSSOUser(userFormSelected.isSSOUser || false);
            //setBaseUserLocation(userFormSelected.companyLocationId);
            setParentId(userFormSelected.parentId);
        }
        else {
            const userLogged = JSON.parse(localStorage.getItem('@Auth:user'));

            form.setFieldsValue({
                isActive: false,
                isEmailSent: false,
                languageId: userLogged.languageId,
                readOnly: readOnly
            });

        }
    }, [userFormSelected]);

    const getParentLocationName = (usersList, parentId) => {
        if (usersList && parentId)
            return usersList?.find(x => x.id == parentId)?.locationName;
    }

    const handleSubmitForm = async (userValues) => {
        var config = {
            title: !userValues.isActive ? t('Prompt.DeactiveUser') + (userFormSelected.docsApprover > 0 ? " This user have " + userFormSelected.docsApprover + " documents linked to him as an approver, when inactivating the user, it may be necessary to make adjustments to them." : "") : t('FormBuilder.BtnSend'),
            content: "Username: " + userValues.userName,
            okText: t('BtnYes'),
            onOk: async () => {
                try {
                    let method = "register";
                    let message = t('Prompt.Sent');
                    let password = userValues.password ? userValues.password : "1234";
                    if (userFormSelected.id) {
                        method = "update";
                        message = t('Prompt.Update');
                        password = userValues.password ? userValues.password : ''; //case password not change
                    }

                    const profiles = userValues.roleId.map((role) => {
                        const data = { roleId: role, locationId: userValues.locationId, topic: userValues.topicId };
                        return data;
                    });

                    const objUserSendToApi = {
                        id: userFormSelected.id,
                        name: userValues.name,
                        userName: userValues.userName,
                        email: userValues.email,
                        phoneNumber: userValues.phoneNumber,
                        password: password,
                        locationId: userValues.locationId,
                        companyLocationId: userValues.companyLocationId,
                        builderLocations: userValues.builderLocationId,
                        isActive: userValues.isActive,
                        profiles: profiles,
                        languageId: userValues.languageId,
                        parentId: userValues.parentId ? userValues.parentId : null,
                        isSSOUser: userValues.isSSOUser,
                        ssoSignInInformation: userValues.ssoSignInInformation,
                        showOnlyMyTasks: showOnlyMyTasks,
                    }

                    await Api.post(`/User/${method}`, objUserSendToApi);
                    success_message(`${message}`);
                    navigate("/user");
                    getUserListData();
                    closeModal(false);
                } catch (error) {
                    exceptionNotificationAPI(error);
                }
            },
        }

        return confirm(config);
    };

    const renderLocationDropdown = (placeholder = "Location", showPath, treeCheckable, multiple, showCheckedStrategy) => {
        return (
            <TreeSelectLocationBase
                size="middle"
                placeholder={placeholder}
                baseLocation={baseUserLocation}
                className="space-search pl-15"
                treeCheckable={treeCheckable}
                showPath={showPath}
                multiple={multiple}
                includeDirectParents={false}
                showCheckedStrategy={showCheckedStrategy}
                disabled={readOnly}
            />
        );
    }

    const renderTopicDropdown = () => {
        return (
            <TreeSelectTopic
                treeCheckable
                disabled={readOnly}
                size="medium"
                placeholder="Topic"
                className="space-search"
                showCheckedStrategy={TreeSelect.SHOW_ALL /* This prop allow to gather all the tree nodes on form submit. Not just leaf/child nodes */}
                loadAllTopics={true}
            />)
    }

    const renderLanguageDropdown = () => {
        if (languagesList == undefined)
            return (<></>);

        let options = languagesList.length > 0
            && languagesList.map((item, key) => {
                return (
                    <Option disabled={readOnly} key={key} value={item.id}>{item.name}</Option>
                );
            });

        return (
            <Select disabled={readOnly} allowClear size="medium" placeholder={t("Language")} className='space-search'>
                {options}
            </Select>
        );
    }

    const setAutoPassword = () => {
        let username = Math.random().toString(36).slice(-6) + Math.floor(Math.random() * 10) + "@" + Math.random().toString(36)
            .toUpperCase().slice(10);


        if (username) {
            form.setFieldsValue({
                password: username
            });
        }
    }

    return (
        <ContentModal>
            <Form
                form={form}
                key="userform"
                layout="vertical"
                onFinish={handleSubmitForm}
                width="500"
                hideRequiredMark
            >
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                            label={t('Name')}
                            disabled={readOnly}
                            name="name"
                            className="ant-modal-label-name"
                            rules={[
                                {
                                    required: true,
                                    message: t('Required.Custom.Message', {
                                        grammaticalPunct: '!', fieldName: (t('Name').toLowerCase())
                                    })
                                }
                            ]}
                        >
                            <Input disabled={readOnly} size="medium" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                            label={t('User.UserName')}
                            disabled={readOnly}
                            className="ant-modal-label-name"
                            name="userName"
                            rules={[
                                {
                                    required: true,
                                    message: t('Required.Custom.Message', {
                                        grammaticalPunct: '!', fieldName: (t('User.UserName').toLowerCase())
                                    })
                                }
                            ]}
                        >
                            <Input size="medium" maxLength="50" autoComplete="username" disabled={readOnly} />
                        </Form.Item>
                    </Col>
                </Row>

                {tenantIsSSOEnabled &&
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                label={t('User.IsSSoUser')}
                                disabled={readOnly}
                                name="isSSOUser"
                                className="ant-modal-label-name"
                            >
                                <Switch disabled={readOnly} onChange={(e) => { setIsSSOUser(e) }} defaultChecked={form.getFieldValue().isSSOUser} />
                            </Form.Item>
                        </Col>
                    </Row>
                }
                {isSSOUser &&
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Form.Item
                                label={t("User.SSOSignInInformation")}
                                name="ssoSignInInformation"
                                className="ant-modal-label-name"
                                disabled={readOnly}
                                rules={[
                                    {
                                        required: true,
                                        message: t('Required.Custom.Message', {
                                            grammaticalPunct: '!', fieldName: (t("User.SSOSignInInformation") + " " + t('Of') + " " + t('User.User').toLowerCase())
                                        })
                                    }
                                ]}
                            >
                                <Input size="medium" disabled={readOnly} />
                            </Form.Item>
                        </Col>
                    </Row>
                }

                {!userFormSelected.id && !isSSOUser &&
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Form.Item
                                label={<label className="legend-card">{t('User.Password')}<Typography.Link onClick={setAutoPassword}> (suggest password) </Typography.Link></label>}
                                className="ant-modal-label-name"
                                name="password"
                                disabled={readOnly}
                                rules={[
                                    {
                                        required: true,
                                        whitespace: true,
                                        message: t('Required.Custom.Message', {
                                            grammaticalPunct: '!', fieldName: (t('User.Password').toLowerCase())
                                        })
                                    }
                                ]}
                            >
                                <Input.Password
                                    size="medium"
                                    disabled={readOnly}
                                    type="password"
                                    iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                    autoComplete="new-password"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                }

                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                            label="E-mail"
                            disabled={readOnly}
                            name="email"
                            className="ant-modal-label-name"
                            rules={[
                                {
                                    required: true,
                                    message: t('Required.Custom.Message', {
                                        grammaticalPunct: '!', fieldName: ("e-mail " + t('Of') + " " + t('User.User').toLowerCase())
                                    })
                                }
                            ]}
                        >
                            <Input disabled={readOnly} size="medium" type="email" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item
                            label={t('User.Phone')}
                            disabled={readOnly}
                            className="ant-modal-label-name"
                            name="phoneNumber"
                        >
                            <MaskedInput
                                mask="+00 00 00000-0000"  // qualquer pattern do IMask
                                maskPlaceholder={null}      // sem placeholder “_”
                                disabled={readOnly}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item
                            label={t('Language')}
                            disabled={readOnly}
                            name="languageId"
                            className="ant-modal-label-name"
                            rules={[
                                {
                                    required: true,
                                    message: t('Required.Custom.Message3', {
                                        grammaticalPunct: '!', fieldName: (t('Language').toLowerCase())
                                    })
                                }
                            ]}
                        >
                            {renderLanguageDropdown()}
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item
                    label={t('User.ShowOnlyMyTasks')}
                    disabled={readOnly}
                    name="showOnlyMyTasks"
                    className="ant-modal-label-name"
                    valuePropName="checked"
                >
                    <Switch disabled={readOnly} value={showOnlyMyTasks} onChange={(e) => { setShowOnlyMyTasks(e) }} />
                </Form.Item>

                <Row gutter={[16, 16]}>
                    <Col xs={12} sm={12}>
                        <Form.Item
                            label={t('User.ReportTo')}
                            disabled={readOnly}
                            name="parentId"
                            className="ant-modal-label-name"
                        >
                            <UserPicker disabled={readOnly} initialIds={[parentId]} mode={""} />
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={12}>
                        <Form.Item
                            label={t('User.ReportTo.Location')}
                            disabled={readOnly}
                            name="parentLocationName"
                            className="ant-modal-label-name"
                        >
                            <Input disabled />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item
                            label={t('User.Roles')}
                            disabled={readOnly}
                            name="roleId"
                            className="ant-modal-label-name"
                            rules={[
                                {
                                    required: true,
                                    message: t('Required.Custom.Message3', {
                                        grammaticalPunct: '!', fieldName: (t('User.Roles').toLowerCase())
                                    })
                                }
                            ]}
                        >
                            <Select
                                mode="multiple"
                                disabled={readOnly}
                                allowClear
                                size="medium"
                                placeholder="Role"
                                className='space-search'
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) => {
                                    return (option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0);

                                }}
                            >
                                {/* {rolesList.length > 0 && rolesList.map((item, key) =>
                                    <Option disabled={readOnly} key={key} value={item.id}>{item.name}</Option>
                                )} */}
                                {rolesList && rolesList.length > 0 && rolesList.map((item, key) => (
                                    <Option disabled={readOnly} key={key} value={item.id}>
                                        {item.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item
                            tooltip={t('Company.Tooltip')}
                            label={t('Company.Location')}
                            disabled={readOnly}
                            className="ant-modal-label-name"
                            name="companyLocationId"
                            rules={[
                                {
                                    required: true,
                                    message: t('Required.Custom.Message3', {
                                        grammaticalPunct: '!', fieldName: (t('Company.Location').toLowerCase())
                                    })
                                }
                            ]}
                        >
                            <TreeSelectLocationBase
                                size="middle"
                                disabled={readOnly}
                                baseLocation={baseUserLocation}
                                placeholder={"Company Location"}
                                className="space-search pl-15"
                                showPath
                                includeDirectParents={false}
                                onChange={(value) => {
                                    form.setFieldsValue({
                                        locationId: undefined,
                                    });
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item
                            tooltip={t('User.User.Tooltip')}
                            label={t('User.User.Location')}
                            disabled={readOnly}
                            className="ant-modal-label-name"
                            name="locationId"
                            rules={[
                                {
                                    required: true,
                                    message: t('Required.Custom.Message3', {
                                        grammaticalPunct: '!', fieldName: (t('User.User.Location').toLowerCase())
                                    })
                                }
                            ]}
                        >
                            <TreeSelectLocationBase
                                baseLocation={baseUserLocation}
                                // disabled={baseUserLocation === undefined ? true : false}
                                disabled={baseUserLocation === undefined || readOnly}
                                size="middle"
                                placeholder={"User Location"}
                                className="space-search pl-15"
                                showPath
                                includeDirectParents={false}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item
                            tooltip={t('User.Builder.Tooltip')}
                            label={t('User.Builder.Location')}
                            disabled={readOnly}
                            className="ant-modal-label-name"
                            name="builderLocationId"
                            rules={[
                                {
                                    required: false,
                                    message: t('Required.Custom.Message3', {
                                        grammaticalPunct: '!', fieldName: (t('User.Builder.Location').toLowerCase())
                                    })
                                }
                            ]}
                        >
                            {renderLocationDropdown("Builder Location", false, true, undefined, TreeSelect.SHOW_CHILD)}
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item
                            label={t('Topic.Title')}
                            disabled={readOnly}
                            name="topicId"
                            className="ant-modal-label-name"
                            rules={[
                                {
                                    required: true,
                                    message: t('Required.Custom.Message3', {
                                        grammaticalPunct: '!', fieldName: (t('Topic.Title').toLowerCase())
                                    })
                                }
                            ]}
                        >
                            {renderTopicDropdown()}
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item
                    label={t('User.Activate')}
                    disabled={readOnly}
                    name="isActive"
                    className="ant-modal-label-name"
                    valuePropName="checked"
                >
                    <Switch disabled={readOnly} />
                </Form.Item>

                <Divider />

                <Row gutter={16}>
                    <Col span={24} style={{ textAlign: 'right' }}>
                        <Button key="back" onClick={() => closeModal(false)}>{t('BtnCancel')}</Button>
                        {!readOnly &&
                            <Button key="submit" htmlType="submit" type="primary" style={{ marginLeft: 8 }}>{t('BtnSave')}</Button>
                        }
                    </Col>
                </Row>
            </Form>
        </ContentModal >
    )
}

export default FormUser;
